'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { TradingCompetitionBoard, TradingCompetitionMetric } from '@/components/social/competition/types';
export interface CompetitionLabels {
  board: (board: TradingCompetitionBoard) => string;
  metric: (metric: TradingCompetitionMetric) => string;
}

/** Translated board and metric labels. Every key is a literal so next-intl's typed keys hold. */
export function useCompetitionLabels() {
  const $ = _c(7);
  const tBoard = useTranslations("competitions.board");
  const tMetric = useTranslations("competitions.metric");
  let t0;
  if ($[0] !== tBoard) {
    t0 = function board(value) {
      switch (value) {
        case "traders":
          {
            return tBoard("traders");
          }
        case "backers":
          {
            return tBoard("backers");
          }
        case "creators":
          {
            return tBoard("creators");
          }
        case "boosters":
          {
            return tBoard("boosters");
          }
      }
    };
    $[0] = tBoard;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const board = t0;
  let t1;
  if ($[2] !== tMetric) {
    t1 = function metric(value_0) {
      switch (value_0) {
        case "pnl":
          {
            return tMetric("pnl");
          }
        case "volume":
          {
            return tMetric("volume");
          }
        case "trades":
          {
            return tMetric("trades");
          }
        case "markets":
          {
            return tMetric("markets");
          }
        case "backed":
          {
            return tMetric("backed");
          }
        case "backs":
          {
            return tMetric("backs");
          }
        case "topMarket":
          {
            return tMetric("topMarket");
          }
        case "totalVolume":
          {
            return tMetric("totalVolume");
          }
        case "marketsCreated":
          {
            return tMetric("marketsCreated");
          }
        case "boostVolume":
          {
            return tMetric("boostVolume");
          }
        case "boosts":
          {
            return tMetric("boosts");
          }
        case "marketsBoosted":
          {
            return tMetric("marketsBoosted");
          }
        case "fairPnl":
          {
            return tMetric("fairPnl");
          }
        case "realizedPnl":
          {
            return tMetric("realizedPnl");
          }
        case "boostsPaid":
          {
            return tMetric("boostsPaid");
          }
        case "pumpProfit":
          {
            return tMetric("pumpProfit");
          }
        case "cashProfit":
          {
            return tMetric("cashProfit");
          }
        case "cashIn":
          {
            return tMetric("cashIn");
          }
        case "cashOut":
          {
            return tMetric("cashOut");
          }
        case "transfers":
          {
            return tMetric("transfers");
          }
      }
    };
    $[2] = tMetric;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const metric = t1;
  let t2;
  if ($[4] !== board || $[5] !== metric) {
    t2 = {
      board,
      metric
    };
    $[4] = board;
    $[5] = metric;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}